import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NotificationIconEnum } from '../../../../../utils/api';

@Component({
    selector: 'app-notification-icon',
    imports: [],
    templateUrl: './notification-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './notification-icon.component.scss'
})
export class NotificationIconComponent {
    icon = input<NotificationIconEnum>(null);
    color = input('#0E79B2');
    classes = input<'size-24' | ''>('');
}
